export default "__VITE_ASSET__BHMKJo$D__"